<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/DeliveryBills"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button type="primary" :disabled="!selection.length" @click="printLabel">打印</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="订单编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入订单编号" clearable/>
          </el-form-item>
          <el-form-item label="销售单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售订单编号" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="客户编号">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="交货日期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" :disabled="scope.row.status === 20" @click="submitRow(scope.row)"> 提交</el-button>
      </template>
    </view-table>
    <edit-page ref="editPage" @save-success="loadData(1)"/>
    <delivery-notice-print ref="deliveryPrint"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import EditPage from "./DeliveryNoticeEdit.vue";
  import DeliveryNoticePrint from "@/views/SalesManage/DeliveryNotice/DeliveryNoticePrint";

  export default {
    name: "DeliveryNoticeList",
    components: {ViewTable, EditPage, DeliveryNoticePrint},
    data() {
      return {
        limits: {
          addAuth: this.$auth(293),
          delAuth: this.$auth(295),
          editAuth: this.$auth(294),
        },
        selection: [],
        ids: [],
        deliveryDateRange: [],
        filter: {
          billNo: "",
          customerNo: "",
          customerName: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          materialNo: "",
          materialName: "",
          salesOrderNo: "",
          specification: "",
        },
        columnsProperty: [
          {
            width: 55,
            align: "center",
            type: "expand",
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.deliveryBillDetails,
                  columns: [
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 160,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      minWidth: 240,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      minWidth: 180,
                    },
                    {
                      title: "数量",
                      key: "quantity",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "交货日期",
                      key: "deliveryDate",
                      width: 120,
                      align: "center",
                    },
                    {
                      title: "单价",
                      key: "price",
                      width: 80,
                      align: "center",
                      render: (h, params) => {
                        return h(
                            "span",
                            params.row.price ? params.row.price : "***",
                        );
                      },
                    },
                    {
                      title: "单位",
                      key: "unit",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "备注",
                      key: "note",
                      width: 240,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            key: "action",
            align: "center",
            width: 240,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.editPage.open(row.pkid);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      selectHandle(selection) {
        this.ids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      deleteHandle(row) {
        this.$http.delete("basic", "sd/DeliveryBills", row.pkid).then(res => {
          if (res.success) {
            this.$message.success("删除成功");
            this.loadData(1);
          }
        });
      },
      printLabel() {
        this.$refs.deliveryPrint.open(this.ids);
      },

      submitRow(row) {
        this.$http.get("basic", `sd/DeliveryBills/submit/${row.pkid}`).then(res => {
          if (res.success) {
            this.$message.success("提交成功");
            this.loadData(1);
          }
        });
      },

      otherAuth(row) {
        if (row.status === 20) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else if (row.status == 10) {
          return {
            editAuth: false,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
            delAuth: false,
          };
        }
      },
    },

  };
</script>
